import Axios from 'axios';
import { getIdentifier } from '@/lib/organization-utils';
var ResourcesOneappTrainingSections = {
  get: function get() {
    var identifier = getIdentifier() || '';
    return Axios("https://open-courses.s3-eu-west-1.amazonaws.com/".concat(identifier.replace('-open', ''), "-open/sections.json"));
  }
};
export default ResourcesOneappTrainingSections;